function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { ACCESS_TOKEN_EXPIRES_AT_KEY, ID_TOKEN_KEY, REFRESH_TOKEN_KEY, TOKEN_KEY, TOKEN_TYPE_KEY, USER_KEY } from './types';
export var DEFAULT_STORAGE_KEYS = {
    tokenKey: TOKEN_KEY,
    userKey: USER_KEY,
    refreshTokenKey: REFRESH_TOKEN_KEY,
    idTokenKey: ID_TOKEN_KEY,
    tokenTypeKey: TOKEN_TYPE_KEY,
    tokenExpiresAtKey: ACCESS_TOKEN_EXPIRES_AT_KEY,
    storageType: 'localStorage'
};
export var resolveStorageKeys = function(storage) {
    return _object_spread({}, DEFAULT_STORAGE_KEYS, storage);
};
